import React from 'react';

const microbeData = [
  { name: 'Halobacterium salinarum', PressureTolerance: 6, TemperatureTolerance: 7, LightExposureTolerance: 4, trait: 'Heat Resistant' },
  { name: 'Thermus thermophilus', PressureTolerance: 5, TemperatureTolerance: 7, LightExposureTolerance: 3, trait: 'Heat Resistant' },
  { name: 'Pseudomonas putida', PressureTolerance: 7, TemperatureTolerance: 5, LightExposureTolerance: 6, trait: 'Light Sensitive' },
  { name: 'Escherichia coli', PressureTolerance: 6, TemperatureTolerance: 4, LightExposureTolerance: 5, trait: 'Light Sensitive' },
  { name: 'Bacillus anthracis', PressureTolerance: 4, TemperatureTolerance: 6, LightExposureTolerance: 4, trait: 'Anaerobic' },
  { name: 'Clostridium acetobutylicum', PressureTolerance: 5, TemperatureTolerance: 5, LightExposureTolerance: 3, trait: 'Anaerobic' },
  { name: 'Vibrio fischeri', PressureTolerance: 7, TemperatureTolerance: 6, LightExposureTolerance: 2, trait: 'Heat Resistant' },
  { name: 'Lactobacillus plantarum', PressureTolerance: 4, TemperatureTolerance: 3, LightExposureTolerance: 6, trait: 'Light Sensitive' },
  { name: 'Salmonella enterica', PressureTolerance: 8, TemperatureTolerance: 7, LightExposureTolerance: 5, trait: 'Anaerobic' },
  { name: 'Pseudomonas aeruginosa', PressureTolerance: 6, TemperatureTolerance: 4, LightExposureTolerance: 4, trait: 'Light Sensitive' },
];

const traitColors = {
  'Pressure Resistant': '#60A5FA',
  'Heat Resistant': '#F87171',
  'Anaerobic': '#A3E635',
  'Light Sensitive': '#FBBF24',
};

const traitIcons = {
  'Pressure Resistant': '🛡️',
  'Heat Resistant': '🔥',
  'Anaerobic': '🦠',
  'Light Sensitive': '☀️',
};

const attrIcons = {
  PressureTolerance: '🛡️',
  TemperatureTolerance: '🌡️',
  LightExposureTolerance: '☀️',
};

function MicrobeCard({ name, PressureTolerance, TemperatureTolerance, LightExposureTolerance, trait }) {
  return (
    <div className="microbe-card flex flex-col items-center rounded-2xl bg-white shadow-md p-4 w-full sm:w-[calc(100%-16px)] md:w-64 min-h-[320px] border border-gray-100 relative">
      {/* Image placeholder */}
      <div className="w-16 h-16 rounded-full flex items-center justify-center mb-2 mt-2" style={{ background: traitColors[trait] + '22' }}>
        <span style={{ fontSize: 36 }}>{traitIcons[trait]}</span>
      </div>
      <div className="font-semibold text-base text-gray-800 mb-2 text-center">{name}</div>
      <div className="text-xs text-gray-400 mb-1">Attributes</div>
      <div className="flex flex-col gap-2 w-full mb-3">
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.PressureTolerance}</span>PressureTolerance</span>
          <span className="font-bold text-gray-800">{PressureTolerance}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.TemperatureTolerance}</span>TemperatureTolerance</span>
          <span className="font-bold text-gray-800">{TemperatureTolerance}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.LightExposureTolerance}</span>LightExposureTolerance</span>
          <span className="font-bold text-gray-800">{LightExposureTolerance}</span>
        </div>
      </div>
      <div className="text-xs text-gray-400 mb-1">Trait</div>
      <div className="flex items-center gap-2 mt-1">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded bg-white border" style={{ background: traitColors[trait], color: '#fff' }}>{traitIcons[trait]}</span>
        <span className="text-sm font-medium text-gray-700">{trait}</span>
      </div>
    </div>
  );
}

export default function FeelTheBurnMicrobeCardsGrid() {
  return (
    <div className="w-full flex flex-wrap gap-4 md:gap-6 justify-center">
      {microbeData.map((microbe, idx) => (
        <MicrobeCard key={microbe.name + idx} {...microbe} />
      ))}
    </div>
  );
} 